import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Home from "../Components/Home/Home";

const HomePage = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, []);
  return (
    <div>
      <Home />
    </div>
  );
};

export default HomePage;
